angular.module('picmonic-common').filter('htmlToPlaintext', function () {
  return function (text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  };
});
